import React, { useContext } from 'react';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import Text from 'components/Text/Text';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './BillTemplateDownloader.module.scss';

const BillTemplateDownloader: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return (
		<>
			<Text
				className={style.text}
				translationNameSpace="form"
				translationKey="billTemplateLabel"
				size="xs"
				theme="neutralLight"
			/>
			<BlobDownloader
				filePath={customerForFullInfo?.billTemplatePath || ''}
				fileExtension="html"
				fileName="bill_template"
				label="downloadHtmlLabel"
			/>
		</>
	);
};

export default React.memo(BillTemplateDownloader);
